import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { governmentBookingSuccess, governmentBookingRequest, governmentBookingFailure, lifestyleGovernmentSuccess, lifestyleGovernmentFailure, lifestyleGovernmentRequest, moreServiceGovernmentSuccess, moreServiceGovernmentFailure, moreServiceGovernmentRequest, newsannouncementGovernmentSuccess, newsannouncementGovernmentFailure, newsannouncementGovernmentRequest, faqGovernmentSuccess, faqGovernmentFailure, faqGovernmentRequest } from "../slice/governmentBookingSlice";
import { config } from "../../../../src/config/global";
const GOVERNMENT_BOOKING_URL = config.GOVERNMENT_BOOKING_SIGNIN;
const PLAN_MY_TRIP_URL = "../../../OSCI/src/component/plan-my-trip/plan-trip.json";
const accessToken = sessionStorage.getItem("accesstoken");
const memberId = sessionStorage.getItem("memberId");
const GovernmentBookingData = async payload => {
  const data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    loader: true
  };
  const response = await api.post(GOVERNMENT_BOOKING_URL, payload, data);
  return response;
};
function* getGovernmentBookingData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(GovernmentBookingData, payload);
    yield put(governmentBookingSuccess(response.data));
  } catch (error) {
    yield put(governmentBookingFailure(error));
  }
}
function* getGovernmentLifeStyleData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(GovernmentBookingData, payload);
    yield put(lifestyleGovernmentSuccess(response.data));
  } catch (error) {
    yield put(lifestyleGovernmentFailure(error));
  }
}
function* getMoreServiceGovernmentData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(GovernmentBookingData, payload);
    yield put(moreServiceGovernmentSuccess(response.data));
  } catch (error) {
    yield put(moreServiceGovernmentFailure(error));
  }
}
function* getNewsannouncementGovernmentData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(GovernmentBookingData, payload);
    yield put(newsannouncementGovernmentSuccess(response.data));
  } catch (error) {
    yield put(newsannouncementGovernmentFailure(error));
  }
}
function* getFaqGovernmentData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(GovernmentBookingData, payload);
    yield put(faqGovernmentSuccess(response.data));
  } catch (error) {
    yield put(faqGovernmentFailure(error));
  }
}
export function* watchGovernmentBooking() {
  yield takeLatest(governmentBookingRequest.type, getGovernmentBookingData);
}
export function* watchGovernmentLifeStyle() {
  yield takeLatest(lifestyleGovernmentRequest.type, getGovernmentLifeStyleData);
}
export function* watchGovernmentMoreService() {
  yield takeLatest(moreServiceGovernmentRequest.type, getMoreServiceGovernmentData);
}
export function* watchGovernmentNewsannouncement() {
  yield takeLatest(newsannouncementGovernmentRequest.type, getNewsannouncementGovernmentData);
}
export function* watchGovernmentFaq() {
  yield takeLatest(faqGovernmentRequest.type, getFaqGovernmentData);
}